import FieldsForm from "../form/selected/fields/FieldsForm";
import HouserulesForm from "../form/selected/houserules/HouserulesForm";
import MessagesForm from "../form/selected/messages/MessagesForm";
import ParkingLocationForm from "../form/selected/parking_location/ParkingLocationForm";
import QuestionnaireForm from "../form/selected/questionnaire/QuestionnaireForm";
import ReferenceCheckForm from "../form/selected/reference_check/ReferenceCheckForm";
import SaltoOpenLockForm from "../form/selected/salto_open_lock/SaltoOpenLockForm";

/**
 * @returns {Array<string>} - An array of available step types.
 */
export function getStepTypes() {
  return [
    "fields",
    "houserules",
    "questionnaire",
    "employee",
    "messages",
    "print",
    "parking_location",
    "salto_open_lock",
    "reference_check",
  ];
}

/**
 * @param {string} type
 * @returns {object|null} - The configuration object for the step type.
 */
export function getStepConfig(type) {
  switch (type) {
    case "start":
      return { form: null, removeable: false };
    case "process_data":
      return { form: null, removeable: false };
    case "fields":
      return { form: FieldsForm, hasForceShowInput: true };
    case "houserules":
      return { form: HouserulesForm, hasForceShowInput: true };
    case "messages":
      return { form: MessagesForm, hasForceShowInput: true };
    case "employee":
      return { form: null, hasForceShowInput: true };
    case "salto_open_lock":
      return { form: SaltoOpenLockForm };
    case "print":
      return { form: null, hasForceShowInput: true };
    case "questionnaire":
      return { form: QuestionnaireForm, hasForceShowInput: true };
    case "parking_location":
      return { form: ParkingLocationForm, hasForceShowInput: true };
    case "reference_check":
      return { form: ReferenceCheckForm, hasForceShowInput: true };
    default:
      return null;
  }
}

/**
 * @param {string} type - The step type.
 * @returns {object} - The initial data for the step type.
 */
export function getStepInitData(type) {
  switch (type) {
    case "houserules":
      return {
        houserules_expiration: 0,
      };
    case "questionnaire":
      return {
        questionnaire_expiration: 0,
        proceed_on_error: false,
        link_to_houserules: false,
      };
    default:
      return {};
  }
}
